import * as React from 'react';
import { Filter } from './components/Filter';
import { PrimarySearch } from './components/PrimarySearch';
import { getSessionSearch } from './utils';
export function Search(props) {
    var initial = props.initial, onSearch = props.onSearch, sessionKey = props.sessionKey, initialHistory = props.initialHistory, _a = props.indexId, indexId = _a === void 0 ? 'id' : _a, defaultField = props.defaultField, placeholder = props.placeholder, data = props.data, thin = props.thin, thick = props.thick, inputClass = props.inputClass, cy = props.cy;
    var _b = React.useState(initialHistory), hist = _b[0], setHist = _b[1];
    React.useEffect(function () {
        if (sessionKey !== undefined) {
            var initHist = getSessionSearch(sessionKey);
            if (initHist !== undefined) {
                setHist(initHist);
            }
        }
    }, []);
    return (React.createElement(Filter, { initial: initial, initialHistory: hist, sessionKey: sessionKey, data: data, onChange: onSearch, indexId: indexId, defaultField: defaultField }, function (_a) {
        var inputRef = _a.inputRef, onChange = _a.onChange, query = _a.query, queryHistory = _a.queryHistory, data = _a.data;
        var isEmpty = query.length === 0;
        return (React.createElement(PrimarySearch, { noResults: data.length === 0, initial: initial, initialHistory: queryHistory, inputRef: inputRef, onChange: onChange, isEmpty: isEmpty, placeholder: placeholder, thin: thin, thick: thick, inputClass: inputClass, cy: cy }));
    }));
}
//# sourceMappingURL=Search.js.map